import { render, staticRenderFns } from "./Telemedicine_New.vue?vue&type=template&id=4214fa22&scoped=true"
import script from "./Telemedicine_New.vue?vue&type=script&lang=js"
export * from "./Telemedicine_New.vue?vue&type=script&lang=js"
import style0 from "./Telemedicine_New.vue?vue&type=style&index=0&id=4214fa22&prod&lang=css"
import style1 from "./Telemedicine_New.vue?vue&type=style&index=1&id=4214fa22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4214fa22",
  null
  
)

export default component.exports